import { useLocation } from 'react-router-dom';
import {
  useCreateLocationTag,
  useGetPaginatedLocationsForTags,
  useParamQuery,
  useUpdateLocations,
} from 'src/hooks';
import { ILocation } from 'src/interfaces';
import { formatQuery } from 'src/utils';

export const useCreateLocationTagPage = () => {
  const { onChangeParams, getParamsValue, activeFilters } = useParamQuery({
    page: ['1'],
  });

  const location = useLocation();

  const createLocationTag = useCreateLocationTag();
  const updateLocations = useUpdateLocations();

  const { data, isLoading: isLoadingLocations } =
    useGetPaginatedLocationsForTags(formatQuery(location.search));

  const pageParam = Number(getParamsValue('page')?.[0] || 1);
  const page = Number.isInteger(pageParam) && pageParam > 0 ? pageParam : 1;

  const locations = data?.locations ?? [];
  const totalPages = data?.totalPages ?? 0;
  const totalCount = data?.totalCount ?? 0;

  const handlePageChange = (
    _event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    onChangeParams('page', [`${value}`]);
  };

  const locationsBase = locations ? (locations as ILocation[]) : [];

  return {
    createLocationTag,
    updateLocations,
    locationsBase,
    totalPages,
    totalCount,
    page,
    isLoadingLocations,
    handlePageChange,
    getParamsValue,
    activeFilters,
  };
};
